import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import ButtonBase from '@mui/material/ButtonBase';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import AllEarsImage from '../../assets/images/full-logo.svg';
import HTMLForm from './pages/common/HTMLForm';

interface Props {
  username?: string;
  logOutUrl?: string;
  homeUrl: string;
  children?: JSX.Element | Array<JSX.Element>;
}

const UserCard = (props: { username: string, logOutUrl: string, isMobileOrTablet: boolean }) => {
  const { username, logOutUrl, isMobileOrTablet } = props;

  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(menuAnchorEl);

  return (
    <>
      {
        isMobileOrTablet ? (
          <Box display="flex" alignItems="center">
            <Typography px={1} borderRadius={1} bgcolor="#F5F6F6" fontSize={20} color="text.secondary">{username[0].toUpperCase()}</Typography>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleUserCardClick}
            >
              <ArrowDropDownIcon fontSize="small" />
            </IconButton>
          </Box>
        ) : (
          <ButtonBase className="user" onClick={handleUserCardClick}>
            <div>
              <Typography variant="caption">WELCOME</Typography>
              <Typography variant="body1" className="name">{username}</Typography>
            </div>
          </ButtonBase>
        )
      }

      <Menu
        anchorEl={menuAnchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        disableScrollLock
      >
        <HTMLForm action={logOutUrl} method="POST">
          {({ onSubmit }) => (
            <MenuItem onClick={onSubmit}>Log out</MenuItem>)}
        </HTMLForm>
      </Menu>
    </>
  );

  function handleUserCardClick(event: React.MouseEvent<HTMLElement>) {
    setMenuAnchorEl(event.currentTarget);
  }

  function handleMenuClose() {
    setMenuAnchorEl(null);
  }
};

export default function TopBar(props: Props): React.ReactElement {
  const { username, logOutUrl, homeUrl, children } = props;

  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AppBar color="inherit" elevation={0} >
      <Box borderBottom={1} borderColor="divider">

      <Box display="flex" justifyContent="space-between"  alignItems="center" py={1} mx="auto" maxWidth="1070px" width="85%">
        <a href={homeUrl}>
          <Avatar src={AllEarsImage} variant="rounded" sizes="40px" alt="All Ears Form Builder" />
        </a>
        <Toolbar variant="dense" sx={{ marginBottom: -1, flexGrow: 1, justifyContent: 'center', minWidth: 0 }}>
          {children}
        </Toolbar>
        {username && <UserCard username={username} logOutUrl={logOutUrl} isMobileOrTablet={isMobileOrTablet} />}
      </Box>
      </Box>
    </AppBar>
  );
}
